import React, { useEffect, useState } from "react";
import { Flex, Notification } from "@telia/teddy";
import { API_URL_RETAILER_IMPORTANT_NEWS } from "../../../api";

type NewsType = "INFO" | "WARNING" | "ERROR";

type ImportantNewsItem = {
    id: string;
    heading: string;
    ingress: string;
    link: string | null;
    newsType: NewsType;
};

const NOTIFICATION_VARIANT: Record<NewsType, "information" | "warning" | "error"> = {
    INFO: "information",
    WARNING: "warning",
    ERROR: "error",
};

const ImportantNewsBanner: React.FC = () => {
    const [news, setNews] = useState<ImportantNewsItem[]>([]);

    useEffect(() => {
        fetch(API_URL_RETAILER_IMPORTANT_NEWS)
            .then((res) => {
                if (!res.ok) {
                    return Promise.resolve([] as ImportantNewsItem[]);
                }
                return res.json() as Promise<ImportantNewsItem[]>;
            })
            .then(setNews)
            .catch(() => {
                setNews([]);
            });
    }, []);

    if (news.length === 0) return null;

    return (
        <Flex direction="column" gap="200" mb="300">
            {news.map((item) => (
                <Notification key={item.id} type="tile" variant={NOTIFICATION_VARIANT[item.newsType]}>
                    <Notification.Icon />
                    <Notification.Text>
                        <strong>{item.heading}</strong>
                        <br />
                        <span style={{ whiteSpace: "pre-wrap" }}>{item.ingress}</span>
                        {item.link && (
                            <>
                                {" "}
                                <a href={item.link} target="_blank" rel="noopener noreferrer">
                                    Les mer
                                </a>
                            </>
                        )}
                    </Notification.Text>
                </Notification>
            ))}
        </Flex>
    );
};

export default ImportantNewsBanner;
